import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfiniteResult } from '../_models/body';

@Injectable({
  providedIn: 'root'
})
export class StreamService {
  constructor(
    private httpClient: HttpClient
  ) { }

  getAll() {
    return this.httpClient.get<InfiniteResult>(`${environment.apiEndpoint}api/Streamer/Query`, {
      params: {
        'PageSize': '-1'
      }
    })
  }

  delete(id) {
    return this.httpClient.delete(`${environment.apiEndpoint}api/Streamer/${id}`)
  }

  create(data) {
    return this.httpClient.post(`${environment.apiEndpoint}api/Streamer`, data)
  }

  udpate(data, id) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Streamer/${id}`, data)
  }


  getStreamingEvents(params) {
    return this.httpClient.get<InfiniteResult>(`${environment.apiEndpoint}api/Streaming/Events/Query`, {
      params: params
    })
  }

  createStreamingEvent(data) {
    return this.httpClient.post(`${environment.apiEndpoint}api/Streaming/Event`, data)
  }

  updateStreamingEvent(data, id) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Streaming/Event/${id}`, data)
  }

  deleteEvent(id) {
    return this.httpClient.delete(`${environment.apiEndpoint}api/Streaming/Event/${id}`)
  }

  setDefaultStreamEvent(id) {
    return this.httpClient.put(`${environment.apiEndpoint}api/Streaming/Event/${id}/SetDefault`, null)
  }

}
